import React, { useEffect, useState } from "react";
import {
  Dialog,
  IconButton,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  makeStyles,
  Button,
} from "@material-ui/core";
import closeIcon from "../../images/closeIcon.svg";
import addIcon from "../../images/add-icon-white.svg"
import warningIcon from "../../images/warningIcon.svg";
import { useTranslation } from "react-i18next";
import { TextBox } from "devextreme-react";
import userEvent from "@testing-library/user-event";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../redux/authentication/selectors";
import SelectBox from "../common/CustomSelectBox";
import { updatePassword, updatePreferredLanguage } from "../../redux/users/thunks";
import { parseJwtToken, stringFormat } from "../../commonFunctions/commonFunctions";
import { getUserData } from "../../redux/authentication/thunks";
import { openModal } from "../../redux/modal/modalSlice";
import { PasswordInput } from "../admin/PasswordInput";

const useStyles = makeStyles({
  divider: {
    backgroundColor: "#000",
  },
  dialogActions: {
    padding: "0.5rem 1.5rem 1.5rem 1.5rem",
    display: "flex",
    alignItems: "center",
    columnGap: "1rem",
  },
});

const initialEditData={
    userId: 0,
    password: "",
    newPassword: "",
    confirmedNewPassword: ""
}

function ProfileDialog(props) {
  const { t, i18n } = useTranslation();
  const { operation, title, open, onClose, handleOnClick, dialogSize } = props;
  const [editData, setEditData] = useState(initialEditData)
  const [editDataLoading, setEditDataLoading] = useState(false)
  const styles = useStyles();
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);
  
  const [changePasswordActive, setChangePasswordActive] = useState(false);

  useEffect(() => {
    if(user){
      setEditData(prevState=> ({...prevState, userId: user?.user?.userId}))

      if(user?.user?.preferredLanguage){
        setSelectedLanguage(user?.user?.preferredLanguage)
      }
    }
  }, [user]);

  const dialogStyles = {
    width: operation !== "delete" ? dialogSize?.width || "550px" : "550px",
    height: operation !== "delete" ? dialogSize?.height || "180px" : null,
  };

  function handleLanguageChange(e) {
    setSelectedLanguage(e.value);
  }

  function handleSaveProfile() {
    const languageData = { preferredLanguage: selectedLanguage };

    dispatch(updatePreferredLanguage({ body: languageData })).then((data) => {
      if (data.error) {
        dispatch(openModal({ type: "warning", message: data.error.message }));
      } else {
        localStorage.setItem("apoloCRM_Language", selectedLanguage);
        const token = parseJwtToken();
        const userData = dispatch(getUserData({ param: token.email }));
        setCurrentLanguage(selectedLanguage);
        i18n.changeLanguage(selectedLanguage);
        onClose();
      }
    });
  }

  function handleChangePassword(){

    setEditDataLoading(true);

    if(editData.password == ""){
      dispatch(openModal({ type: "warning", message: stringFormat(t("RequiredFieldTemplate"), t("Password")) }));
      setEditDataLoading(false);
      return false;
    }
    if(editData.newPassword == ""){
      dispatch(openModal({ type: "warning", message: stringFormat(t("RequiredFieldTemplate"), t("NewPassword")) }));
      setEditDataLoading(false);
      return false;
    }
    if(editData.confirmedNewPassword == ""){
      dispatch(openModal({ type: "warning", message: stringFormat(t("RequiredFieldTemplate"), t("ConfirmNewPassword")) }));
      setEditDataLoading(false);
      return false;
    }
    if(editData.newPassword != editData.confirmedNewPassword){
      dispatch(openModal({ type: "warning", message: t("PasswordsDoNotMatch") }));
      setEditDataLoading(false);
      return false;
    }

    const bodyData = {
      userId: user?.user?.userId,
      password: editData.password,
      newPassword: editData.newPassword
    };

    dispatch(updatePassword({ body: bodyData })).then((data) => {
      if (data.error) {
        //dispatch(openModal({ type: "warning", message: data.error.message }));
        dispatch(openModal({ type: "warning", message: t("UpdatePasswordFail") }));
        
      } else {
        dispatch(openModal({ type: "success", message: t("UpdatePasswordSuccess") }));
        setChangePasswordActive(false);
      }

      setEditDataLoading(false);
    });
  }

  function toggleChangePassword(){
    setChangePasswordActive(!changePasswordActive);
    setEditData(initialEditData);
    setEditDataLoading(false);
  }
  function handleChangePasswordValue(password){
      setEditData(prevState=> ({...prevState, password: password.value}))
  }
  function handleChangeNewPasswordValue(newPassword){
      setEditData(prevState=> ({...prevState, newPassword: newPassword.value}))
  }
  function handleChangeConfirmedNewPasswordValue(confirmedNewPassword){
      setEditData(prevState=> ({...prevState, confirmedNewPassword: confirmedNewPassword.value}))
  }

  return (
    <Dialog
      PaperProps={{ square: true }}
      maxWidth={"xl"}
      open={open}
      onClose={onClose}
    >
      <div style={dialogStyles}>
        {operation === "delete" && <div className="warning-bar"></div>}
        <DialogTitle disableTypography className="titleStyles">
          <span>{title}</span>
          <IconButton size="small" onClick={onClose}>
            <img height={15} src={closeIcon} title={"Fechar"} />{" "}
          </IconButton>
        </DialogTitle>
        <Divider classes={{ root: styles.divider }} orientation="horizontal" />
        <DialogContent>
          <div className="edit-values-wrapper">

            {changePasswordActive == false ? (
              <>
                <TextBox
                  label={t("User")}
                  labelMode={"floating"}
                  id={"user"}
                  disabled={true}
                  value={user?.user?.userName}
                ></TextBox>
                <SelectBox
                  label={t("Language.Title")}
                  dataSource={[
                    {
                      display: t("Language.pt-BR"),
                      value: "pt-BR",
                    },
                    {
                      display: t("Language.en-US"),
                      value: "en-US",
                    },
                    {
                      display: t('Language.es-ES'),
                      value: 'es-ES',
                    },
                    {
                      display: t('Language.de-DE'),
                      value: 'de-DE',
                    },
                  ]}
                  value={selectedLanguage}
                  displayExpr={"display"}
                  valueExpr={"value"}
                  onValueChanged={handleLanguageChange}
                ></SelectBox>

                <div style={{display: "flex", alignItems: "flex-end", fontWeight: "700", justifyContent: "end", marginBottom: "1rem"}}>
                  <div><Button size="small" variant="contained" color="primary" startIcon={<i className="icon icon-refresh"></i>} onClick={toggleChangePassword}>{t("ChangePassword")}</Button></div>
                </div>
              </>
          ) : (<>
              <div style={{display: "flex", fontWeight: "700", justifyContent: "startend"}}>
                <div style={{color: "#333" }} >{t("ChangePassword")}</div>
              </div>
              <TextBox
                  id={"password"}
                  mode="password"
                  label={t("CurrentPassword")}
                  labelMode={"floating"}
                  onValueChanged={handleChangePasswordValue}
                ></TextBox>

                <TextBox
                  id={"new-password"}
                  mode="password"
                  label={t("NewPassword")}
                  labelMode={"floating"}
                  onValueChanged={handleChangeNewPasswordValue}
                ></TextBox>

                <TextBox
                  id={"new-password"}
                  mode="password"
                  label={t("ConfirmNewPassword")}
                  labelMode={"floating"}
                  onValueChanged={handleChangeConfirmedNewPasswordValue}
                ></TextBox>

                {((editData.newPassword != "" && editData.confirmedNewPassword != "") && (editData.newPassword != editData.confirmedNewPassword)) && 
                  <span>{t("PasswordsDoNotMatch")}</span>
                }
          </>)}
          </div>
        </DialogContent>
        <DialogActions
          classes={{ root: styles.dialogActions }}
          style={{
            justifyContent:
              operation !== "delete" ? "space-between" : "flex-end",
          }}
        >
          <>
            <Button
              onClick={changePasswordActive ? toggleChangePassword : onClose}
              color="primary"
              variant="outlined"
              disabled={changePasswordActive ? editDataLoading : false}
              >
              {t("Cancel")}
            </Button>
            <Button
              onClick={changePasswordActive ? handleChangePassword : handleSaveProfile}
              color="primary"
              variant="contained"
              disabled={changePasswordActive ? editDataLoading : false}
            >
              {t("Save")}
            </Button>
          </>
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default ProfileDialog;
